<div id="filter">
  <!-- Created At -->

  <app-filter-date
    *ngIf="showCreated"
    dateType="created"
    [filter]="filter"
    (filterEvent)="setFilterValue($event)"
  >
  </app-filter-date>
  <!-- Users -->

  <app-filter-user
    *ngIf="showUsers"
    [filter]="filter"
    (filterEvent)="setFilterValue($event)"
  >
  </app-filter-user>

  <!-- Modified At -->

  <app-filter-date
    *ngIf="showModified"
    dateType="modified"
    [filter]="filter"
    (filterEvent)="setFilterValue($event)"
  >
  </app-filter-date>

  <!-- Clear All -->

  <p
    *ngIf="filterIsDirty()"
    (click)="resetFilter()"
    class="flwmn-para-1 flwmn-pointer flwmn-text-primary mb-0"
    matRipple
  >
    Clear all
  </p>
</div>
